export default (function (x) { return function () { return x; }; });
//# sourceMappingURL=constant.js.map